import { lazy, Suspense, useEffect, useState } from "react";
import { Navigate, NavLink, Outlet, useLocation } from "react-router-dom";
import styles from "./App.module.css";
import { Sidebar } from "./Sidebar";
import { SalesWatcher } from "./components/SalesWatcher";
import { NotificationBell } from "./components/NotificationBell";
import { UserMenu } from "./components/UserMenu";
import { Icon } from "./components/Icon";
import { forhandsHentKvartalsrapport } from "./lib/report";
import { erSkjultRute, useModuler } from "./lib/moduler";

const COLLAPSE_KEY = "gb-sidebar-collapsed";

// Martin (assistenten nede til høyre) lastes for seg, så hovedfilen ikke vokser
const Martin = lazy(() => import("./components/Martin").then((m) => ({ default: m.Martin })));

/** Ramme som i ACL-portalene: fast sidemeny til venstre på store skjermer;
 *  på mobil (≤ 860 px) en topplinje med menyknapp og menyen skjøvet inn fra venstre. */
export function Layout() {
  const [collapsed, setCollapsed] = useState(() => {
    try {
      return localStorage.getItem(COLLAPSE_KEY) === "1";
    } catch {
      return false;
    }
  });
  const [navOpen, setNavOpen] = useState(false);
  const loc = useLocation();
  const { skjulte } = useModuler();

  useEffect(() => {
    try {
      localStorage.setItem(COLLAPSE_KEY, collapsed ? "1" : "0");
    } catch {
      /* ignore */
    }
  }, [collapsed]);

  // Lukk mobilmenyen ved sidebytte
  useEffect(() => setNavOpen(false), [loc.pathname, loc.search]);

  // Kvartalsrapporten tar ~11 s å regne ut: hent den i bakgrunnen litt etter
  // innlogging, så siden er klar når man går inn (lib/report.ts). Venter 10 s, så
  // den ikke konkurrerer med Hjem om databasen (S0) mens siden laster (Erik 03.11.2026).
  useEffect(() => {
    const t = window.setTimeout(() => void forhandsHentKvartalsrapport(), 10_000);
    return () => window.clearTimeout(t);
  }, []);

  return (
    <div className={styles.app}>
      {navOpen && <div className={styles.overlay} onClick={() => setNavOpen(false)} />}
      <Sidebar
        collapsed={collapsed}
        open={navOpen}
        onToggle={() => setCollapsed((c) => !c)}
      />
      <div className={styles.main}>
        <header className={styles.topbar}>
          <button
            type="button"
            className={styles.menuBtn}
            onClick={() => setNavOpen(true)}
            aria-label="Meny"
          >
            <Icon name="menu" size={18} />
          </button>
          <NavLink to="/" className={styles.topbarBrand}>
            <img src="/logo/gjelsten-bolig-liggende.svg" alt="Gjelsten Bolig" />
          </NavLink>
          <div className={styles.topbarRight}>
            <NotificationBell />
            <UserMenu placement="down" />
          </div>
        </header>
        <main className={styles.content}>
          {/* Sider i en modul som er skjult under Innstillinger → Moduler, sender til Hjem */}
          {erSkjultRute(loc.pathname, skjulte) ? <Navigate to="/" replace /> : <Outlet />}
        </main>
      </div>
      <SalesWatcher />
      <Suspense fallback={null}>
        <Martin />
      </Suspense>
    </div>
  );
}
